// extracted by mini-css-extract-plugin
export default {"bg_custom":"client_profile_bg_custom__fmt03","line":"client_profile_line__XVP8V","dashboard":"client_profile_dashboard__I33N1","profiledata":"client_profile_profiledata__e-hsX"};